import colors from '../colors';

const iconSize = '22px';

const listItemButton = {
  MuiListItemButton: {
    styleOverrides: {
      root: {
        '&.Mui-selected': {
          background: colors.palette.neutral.light,
        },

        '.MuiListItemIcon-root': {
          minWidth: '35px',
        },

        '.MuiSvgIcon-root, svg': {
          fill: colors.palette.primary.main,
          height: iconSize,
          width: iconSize,
        },

        '.MuiTypography-root': {
          color: colors.palette.primary.main,
          fontSize: '16px',
          fontWeight: 700,
        },
      },
    },
  },
};

export default listItemButton;
